module.exports = __webpack_public_path__ + "static/img/AI .a199ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/AI .png
// module id = GCC3
// module chunks = 12